/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.drawsParticipations

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.drawsParticipations.internal.DrawsParticipationsUseCase
import features.drawsParticipations.internal.DrawsParticipationsUseCase.Params
import features.drawsParticipations.models.ParticipationsModel


typealias DrawsParticipationsState = CFlow<DrawsParticipationsUseCaseResult?>

typealias DrawsParticipationsUseCaseResult = Result<ParticipationsModel>

fun DrawsParticipationsUseCaseResult.serializeDrawsParticipationsApiResult(): SerializedResult<String> {
    return this.toJsonResult<ParticipationsModel>()
}

/**
 * Serializes [DrawsParticipationsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun DrawsParticipationsState.serializeDrawsParticipationsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<ParticipationsModel>()
    }.asCFlow()
}

/**
 * Acquires business draws participations. [Api] class
 */
class DrawsParticipationsApi : Api() {

    val drawsParticipationsState: DrawsParticipationsState
        get() = _drawsParticipationsState.asCFlow()

    companion object {
        private val _drawsParticipationsState: MutableStateFlow<DrawsParticipationsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val drawsParticipationsUseCase = DrawsParticipationsUseCase()

    /**
     * Acquires business draws participations.
     */
    suspend fun getDrawsParticipations(
        overrideHeaders: Map<String, String>? = null,

    ): Result<ParticipationsModel> {
        /* set state to Loading as soon as function is called */
        _drawsParticipationsState.value = Loading()
        val result = this.drawsParticipationsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _drawsParticipationsState.value = result
            return@drawsParticipationsUseCase result
        }
        return result
    }

}
